import React from "react";
import './Groups.css';
import {useAuthorizationContext} from "../../../context/authorizationContext";
import {PlaylistRow, PlaylistTable} from "./Groups";
import {GoToLoginButton} from "../../common/Buttons";

export const Tempo = () => {
    const {loggedIn} = useAuthorizationContext();
    return (
        <div>
            <div className="group pageContentSegment">
                <h1>Tempo playlists</h1>
                <p>Liked Songs Manager supports creating playlists of various BPM ranges.</p>
                <PlaylistTable>
                    <PlaylistRow name={"Very Slow (1-50 BPM)"} availableFree={true}/>
                    <PlaylistRow name={"Slow (51-70 BPM)"} availableFree={true}/>
                    <PlaylistRow name={"Midtempo (71-110 BPM)"} availableFree={true}/>
                    <PlaylistRow name={"Fast (111-160 BPM)"} availableFree={true}/>
                    <PlaylistRow name={"Very Fast (161+ BPM)"} availableFree={true}/>
                </PlaylistTable>
                {!loggedIn ? <GoToLoginButton/> : null}
            </div>
        </div>
    );
}

